module.exports = __webpack_public_path__ + "static/media/algo1.b8f57351.jpg";